import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Yearbook {
  name: string;
  api_token: string;
}

export interface YearbookDetaiInfor {
  errors: unknown;
  Yearbook: Yearbook;
  isAuthenticated: boolean;
}

@Module
export default class YearbookDetail
  extends VuexModule
  implements YearbookDetaiInfor
{
  errors = {};
  Yearbook = {} as Yearbook;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get YearbookDetail() {
    return this.yearbookDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.YEARBOOK_DETAIL_DATA](Yearbook) {
    this.yearbookDetailData = Yearbook;
  }
  @Action
  [Actions.YEARBOOK_DETAIL](payload) {
    return ApiService.getDataDetail("/niengiam", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.YEARBOOK_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
